import type { ParsedTsr } from "./parse";
import type { VerificationResult } from "./verify";

export const APP_VERSION = "0.1.0";

export function buildReport(
  fileName: string,
  parsed: ParsedTsr,
  verification: VerificationResult | null
) {
  const { signedData: _sd, tokenBytes: _tb, ...serializable } = parsed;
  return {
    tool: "sunlit-tsa tsr-viewer",
    version: APP_VERSION,
    generatedAt: new Date().toISOString(),
    file: fileName,
    parsed: serializable,
    verification,
    disclaimer:
      "A timestamp token proves the TSA attested to this hash at this time. " +
      "It does not prove the document's contents are true.",
  };
}

export function downloadJson(name: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
